import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "position-relative" }
const _hoisted_11 = { class: "text-danger" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "position-relative" }
const _hoisted_15 = { class: "text-danger" }
const _hoisted_16 = { class: "col-lg-3" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "text-danger" }
const _hoisted_19 = { class: "col-lg-3" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "position-relative" }
const _hoisted_22 = { class: "text-danger" }
const _hoisted_23 = { class: "col-lg-6" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "position-relative" }
const _hoisted_26 = { class: "text-danger" }
const _hoisted_27 = { class: "col-lg-6" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "position-relative" }
const _hoisted_30 = { class: "text-danger" }

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { UserDataPayload, UserDataResponse } from "@/types/interface/user";
import { useUserStore } from "@/stores/master/user";
import { useRegionStore } from "@/stores/master/region";
import { mapOptionMultiselect } from "@/utils/helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateUser',
  setup(__props) {

const idUser = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const userStore = useUserStore();
const detailUser = ref<UserDataResponse>();
const titlePage = ref("Form Create User");
const listPhoneCode = ref<any>([]);
const regionStore = useRegionStore();

const validationSchema = toTypedSchema(
  zod.object({
    name: zod.string().nonempty({ message: "Name is required" }),
    phone_code: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.string()
    ),
    email: zod.string().email().nonempty({ message: "Email is required" }),
    work_phone: zod.string().nonempty(),
    username: zod.string().nonempty({ message: "Username is required" }),
    password: zod.string().min(6).nonempty({ message: "Password is required" }),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: name } = useField<string>("name");
const { value: phone_code } = useField<string>("phone_code");
const { value: email } = useField<string>("email");
const { value: work_phone } = useField<string>("work_phone");
const { value: username } = useField<string>("username");
const { value: password } = useField<string>("password");

const onSubmit = handleSubmit(async () => {
  isLoading.value = true;
  const payloadUser: UserDataPayload = {
    name: name.value,
    phone_code: phone_code.value?.value,
    email: email.value,
    phone: work_phone.value,
    username: username.value,
    password: password.value,
    role_id: 1,
  };

  const responseApi = ref<any>();
  if (isEdit.value == true) {
    responseApi.value = await userStore.dispatchUpdate(
      idUser.value,
      payloadUser
    );
  } else {
    responseApi.value = await userStore.dispatchCreate(payloadUser);
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value ? "User Successfully Updated" : "User Successfully Added"
      );
      router.push("/master/user");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadDetailUser = async () => {
  const { success, message } = await userStore.dispatchDetail(idUser.value);
  if (success) {
    detailUser.value = await userStore?.user?.data;
    name.value = detailUser.value?.name;
    phone_code.value = { value: "62", label: "+62 - Indonesia" };
    email.value = detailUser.value?.email;
    work_phone.value = detailUser.value?.phone;
    username.value = detailUser.value?.username;
  }
};

const loadCountry = async () => {
  const { success, message } = await regionStore.dispatchGetCountry();
  listPhoneCode.value = mapOptionMultiselect(
    await regionStore.countries,
    "Phonecode",
    "phone_name"
  );
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idUser.value = router.currentRoute.value.params.id.toString();
    titlePage.value = "Form Edit User";
    loadDetailUser();
  }
  loadCountry();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(titlePage.value), 1),
            _cache[7] || (_cache[7] = _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/master/user"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List User ")
            ], -1))
          ]),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", {
                        for: "username",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Name "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          name: "name",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                          placeholder: "Name",
                          type: "text",
                          class: "form-control text-dark ps-5"
                        }, null, 512), [
                          [_vModelText, _unref(name)]
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("i", {
                          class: "ri-user-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                          style: {"top":"5px !important"}
                        }, null, -1))
                      ]),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(errors).name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[11] || (_cache[11] = _createElementVNode("label", {
                        for: "username",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Email "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                          name: "email",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
                          placeholder: "Email",
                          type: "email",
                          class: "form-control text-dark ps-5"
                        }, null, 512), [
                          [_vModelText, _unref(email)]
                        ]),
                        _cache[10] || (_cache[10] = _createElementVNode("i", {
                          class: "ri-mail-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                          style: {"top":"5px !important"}
                        }, null, -1))
                      ]),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(errors).email), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", {
                        for: "username",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Phone Code "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_unref(vSelect), {
                        options: listPhoneCode.value,
                        name: "phone_code",
                        modelValue: _unref(phone_code),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(phone_code) ? (phone_code).value = $event : null)),
                        placeholder: "Phone Code"
                      }, null, 8, ["options", "modelValue"]),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(errors).phone_code), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", {
                        for: "username",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Work Phone "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_21, [
                        _withDirectives(_createElementVNode("input", {
                          name: "work_phone",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(work_phone) ? (work_phone).value = $event : null)),
                          placeholder: "81217018168",
                          type: "text",
                          class: "form-control text-dark ps-5"
                        }, null, 512), [
                          [_vModelText, _unref(work_phone)]
                        ]),
                        _cache[13] || (_cache[13] = _createElementVNode("i", {
                          class: "ri-phone-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                          style: {"top":"5px !important"}
                        }, null, -1))
                      ]),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(errors).work_phone), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _cache[16] || (_cache[16] = _createElementVNode("label", {
                        for: "username",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Username "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          name: "username",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(username) ? (username).value = $event : null)),
                          placeholder: "Username",
                          type: "text",
                          class: "form-control text-dark ps-5"
                        }, null, 512), [
                          [_vModelText, _unref(username)]
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("i", {
                          class: "ri-user-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                          style: {"top":"5px !important"}
                        }, null, -1))
                      ]),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(errors).username), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _cache[18] || (_cache[18] = _createElementVNode("label", {
                        for: "username",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Password "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_29, [
                        _withDirectives(_createElementVNode("input", {
                          name: "password",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
                          placeholder: "Password",
                          type: "text",
                          class: "form-control text-dark ps-5"
                        }, null, 512), [
                          [_vModelText, _unref(password)]
                        ]),
                        _cache[17] || (_cache[17] = _createElementVNode("i", {
                          class: "ri-lock-fill position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                          style: {"top":"5px !important"}
                        }, null, -1))
                      ]),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(errors).password), 1)
                    ])
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Save ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})